import React from 'react';
import { Box, Typography } from 'glints-aries';

export const Paragraph: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Box mb={24}>
      <Typography.Paragraph variant="caption" shouldSetLineHeight={true}>
        {children}
      </Typography.Paragraph>
    </Box>
  );
};
